const persistLocalStorage = <T>(key: string, value: T) => {
    let toSave = value;

    if (typeof toSave === 'string') {
        window.localStorage.setItem(key, toSave);
        return;
    }

    window.localStorage.setItem(key, JSON.stringify(toSave));
};

const getLocalStorage = (key: string, parse: boolean) => {
    const value = window.localStorage.getItem(key);

    if (value) {
        return parse ? JSON.parse(value) : value;
    }

    return null;
};

const clearLocalStorage = (key: string) => {
    window.localStorage.removeItem(key);
};

export const localStorageService = {
    create: persistLocalStorage,
    get: getLocalStorage,
    clear: clearLocalStorage,
};
